import { useAuthContext } from '../../contexts/AuthContext';
import { Brand } from '../../models/Brand';
import CreateSessionWizard from './CreateSessionWizard';
import CreateBmwSessionWizard from './CreateBmwSessionWizard';

const CreateNewSession = () => {
    const { user } = useAuthContext();

    if (user?.brand === Brand.BMW) {
        return <CreateBmwSessionWizard />;
    }

    return <CreateSessionWizard />;
};

export default CreateNewSession;
